import React from 'react';
import './TopBar.css';

export type TopBarSidebar = 'none' | 'expanded' | 'collapsed';

interface IProps {
  sidebar?: TopBarSidebar;
  brand?: React.ReactNode;
  children?: React.ReactNode;
}

export default function TopBar({ sidebar = 'none', brand, children }: IProps) {
  return <>
    {brand && <div className="top-bar-brand d-flex align-items-center bg-white">{brand}</div>}
    <header
      className={`navbar navbar-expand-sm navbar-end navbar-light bg-white border-bottom fixed-top py-0${sidebar === 'expanded' ? ' top-bar-offset' : ''}`}
      style={{ zIndex: 100, minHeight: 'var(--header-height)', transition: 'left 0.2s ease-in-out' }}>
      <div className="container-fluid">
        <div className="navbar-nav-wrap">
          <nav className="navbar-collapse">
            <ul className="navbar-nav align-items-center gap-2" style={{ height: 'var(--header-height)' }}>
              {children}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  </>;
}
